import {IRedirectStep, ISendNotificationStep} from "~/interfaces/processFlowInterfaces"
import {CallToActionType} from "~/enums/processFlows/callToActionType"
import ProcessFlowCallToAction from "~/models/processFlows/callToActions/processFlowCallToAction"
import assertNever from "../../../global/assetNever"
import {InstanceHelper} from "~/helpers/instanceHelper"
import ShowDetailViewCallToAction from "~/models/processFlows/callToActions/showDetailViewCallToAction"
import ShowFormSubmissionCallToAction from "~/models/processFlows/callToActions/showFormSubmissionCallToAction"
import ShowFormProfileCallToAction from "~/models/processFlows/callToActions/showFormProfileCallToAction";
import NewFormSubmissionCallToAction from "~/models/processFlows/callToActions/newFormSubmissionCallToAction";
import ShowListViewCallToAction from "~/models/processFlows/callToActions/showListViewCallToAction"
import ShowFileCallToAction from '~/models/processFlows/callToActions/showFileCallToAction'
import EditFormSubmissionCallToAction from '~/models/processFlows/callToActions/editFormSubmissionCallToAction';

export default class ProcessFlowCallToActionFactory {
  static create(parent: ISendNotificationStep | IRedirectStep, options: {actionType: CallToActionType, json: object, buttonLabelRequired: boolean} = {actionType: null, json: {}, buttonLabelRequired: false}): ProcessFlowCallToAction {
    options.json = options.json || {}
    let cta: ProcessFlowCallToAction = null
    switch (options.actionType) {
      case CallToActionType.ViewRecord:
        cta = new ShowDetailViewCallToAction('call_to_action', options)
        break
      case CallToActionType.EditFormSubmission:
        cta = new EditFormSubmissionCallToAction('call_to_action', options)
        break
      case CallToActionType.ViewFormSubmission:
        cta = new ShowFormSubmissionCallToAction('call_to_action', options)
        break
      case CallToActionType.FormProfile:
        cta = new ShowFormProfileCallToAction('call_to_action', options)
        break
      case CallToActionType.NewFormSubmission:
        cta = new NewFormSubmissionCallToAction('call_to_action', options)
        break
      case CallToActionType.ListView:
        cta = new ShowListViewCallToAction('call_to_action', options)
        break
      case CallToActionType.File:
        cta = new ShowFileCallToAction('call_to_action', options)
        break
      default:
        assertNever(options.actionType)
        break
    }

    return cta
  }

  static findOrCreate(idsToCheck: string | string[], processFlowStep: ISendNotificationStep | IRedirectStep, actionType: CallToActionType, json: object = {}, options: { buttonLabelRequired?: boolean } = {}): ProcessFlowCallToAction {
    let cta: ProcessFlowCallToAction = null
    for (const id of InstanceHelper.toArray(idsToCheck)) {
      cta = ProcessFlowCallToAction.repo.find(id)
      if (cta) return cta
    }
    return ProcessFlowCallToActionFactory.create(processFlowStep, { actionType, json, buttonLabelRequired: options.buttonLabelRequired })
  }
}